import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { validation } from './helpers';
const initialState = {};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.validateField, (state, { payload }) => {
        const { form, field, value, validationConfig, cb = null, isTouched = false } = payload;
        return {
            ...state,
            ...{
                [form]: {
                    ...state[form],
                    ...{
                        [payload.field]: {
                            value: value?.label ? value?.label : value,
                            id: value?.label ? value?.value : '',
                            isTouched,
                            errors: validation(value, validationConfig[form][field], cb),
                        },
                    },
                },
            },
        };
    })
        .addCase(actions.setValidateConfig, (state, { payload }) => ({
        ...state,
        ...payload,
    }))
        .addCase(actions.validateForm, (state) => ({
        ...state,
    }))
        .addCase(actions.resetValidationFields, (state, { payload }) => {
        const { validationConfig, form } = payload;
        return {
            ...state,
            ...{
                [form]: validationConfig[form],
            },
        };
    })
        .addCase(actions.setFieldErrors, (state, { payload }) => {
        const { form, field, validationConfigField, cb } = payload;
        return {
            ...state,
            ...{
                [form]: {
                    ...state[form],
                    ...{
                        [field]: {
                            ...state[form][field],
                            errors: validation(state[form][field].value, validationConfigField, cb),
                        },
                    },
                },
            },
        };
    });
});
